/**
 * Console Analytics plugin
 * @link https://github.com/davidwells/analytics?tab=readme-ov-file#creating-analytics-plugins
 * @param {object} pluginConfig - Plugin settings
 * @param {string} [pluginConfig.pageEvent] - Event name to use for page() events (default to page path)
 * @return {object} Analytics plugin
 * @example
 *
 * consolePlugin({
 *   pageEvent: 'Page View'
 * })
 */
export function consolePlugin(pluginConfig: any) {
  return {
    name: 'console',
    config: pluginConfig,
    initialize: () => {
      console.log('Analytics: initialize');
    },
    identify: ({ payload }: any) => {
      console.log('Analytics: identify', { payload });
    },
    page: ({ payload }: any) => {
      console.log('Analytics: page', {
        pageEvent: pluginConfig.pageEvent,
        payload,
      });
    },
    track: ({ payload }: any) => {
      console.log('Analytics: track', { payload });
    },
    loaded: () => {
      return true;
    },
    reset: () => {
      console.log('Analytics: reset');
    },
    /* Custom methods to add .alias call */
    methods: {
      /**
       * @param  {string} [alias] - A unique identifier that you want to use for this user in the future.
       * @param  {string} [original] - The current identifier being used for this user.
       */
      alias(alias: string, original: string) {
        console.log('Analytics: alias', {
          alias,
          original,
        });
      },
    },
  };
}
